import {API} from '@/classes/api/api.class';
import {CreateProductRequestDto} from '@/classes/dto/catalogue-manager/product/request/CreateProduct.request.dto';
import {LeanDocument, Types} from 'mongoose';
import {ProductDocument} from '@/documentTypes/catalogue-manager/Product.document';
import {FindByIdOptionsRequestDto} from '@/classes/dto/_common/request/FindByIdOptions.request.dto';
import {FindProductRequestDto} from '@/classes/dto/catalogue-manager/product/request/FindProduct.request.dto';
import {UpdateProductRequestDto} from '@/classes/dto/catalogue-manager/product/request/UpdateProduct.request.dto';
import {ScheduledProductSeriesDocument} from '@/documentTypes/catalogue-manager/ScheduledProductSeries.document';
import {
    CreateScheduledProductSeriesRequestDto,
} from '@/classes/dto/catalogue-manager/scheduled-product-series/request/CreateScheduledProductSeries.request.dto';
import {
    UpdateScheduledProductSeriesRequestDto,
} from '@/classes/dto/catalogue-manager/scheduled-product-series/request/UpdateScheduledProductSeries.request.dto';

import {
    FindScheduledProductSeriesRequestDto,
} from '@/classes/dto/catalogue-manager/scheduled-product-series/request/FindScheduledProductSeries.request.dto';
import {
    GetShipmentProductRequestDto,
} from '@/classes/dto/catalogue-manager/shipment-product/GetShipmentProduct.request.dto';

export class CatalogueManagerApi extends API {
    static service = 'catalogue-manager';

    static product = {
        create: async (data: CreateProductRequestDto): Promise<Types.ObjectId> => {
            return this.post('product', data);
        },
        find: async (data: FindProductRequestDto): Promise<{
            products: LeanDocument<ProductDocument>[];
            maxPage: number;
        }> => {
            return this.get('product', data);
        },
        findById: async (id: Types.ObjectId | string, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<ProductDocument>> => {
            return this.get(`product/${id}`, options);
        },
        update: async (id: Types.ObjectId | string, data: UpdateProductRequestDto): Promise<Types.ObjectId> => {
            return this.put(`product/${id}`, data);
        },
    }
    static scheduledProductSeries = {
        create: async (data: CreateScheduledProductSeriesRequestDto): Promise<Types.ObjectId> => {
            return this.post('scheduled-product-series', data);
        },
        find: async (data: FindScheduledProductSeriesRequestDto): Promise<{
            scheduledProductSeries: LeanDocument<ScheduledProductSeriesDocument>[];
            maxPage: number;
        }> => {
            return this.get('scheduled-product-series', data);
        },
        findById: async (id: Types.ObjectId | string, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<ScheduledProductSeriesDocument>> => {
            return this.get(`scheduled-product-series/${id}`, options);
        },
        update: async (id: Types.ObjectId | string, data: UpdateScheduledProductSeriesRequestDto): Promise<Types.ObjectId> => {
            return this.put(`scheduled-product-series/${id}`, data);
        },
    }
    static shipmentProduct = {
        getShipmentProduct: (request: GetShipmentProductRequestDto): Promise<{ productName: string; productId: Types.ObjectId; cost: number; name: string; productGrossPrice: number}> => {
            return this.get(`shipment-product/${request.productId}/${request.destinationCountry}`);
        },
    };
}
